import { redirectIfNotAuthenticated } from '../actions/user';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { showAppLoaderSelector, userIdSelector } from '../helpers/selectors';
import { Outlet } from 'react-router-dom';

export default function Authenticated({ location }) {
  const dispatch = useDispatch();
  const userId = useSelector(userIdSelector);
  const showAppLoader = useSelector(showAppLoaderSelector);

  const [redirected, setRedirected] = useState(false);

  useEffect(() => {
    // Wait for the Keycloak SSO session check (silent check-sso) to settle before
    // deciding the user is unauthenticated, otherwise a hard refresh would redirect
    // to the login popup before the session is restored.
    if (showAppLoader) return;

    if (userId) {
      setRedirected(false);
    } else if (!redirected) {
      setRedirected(true);
      dispatch(redirectIfNotAuthenticated(location));
    }
  }, [userId, location, showAppLoader]);

  if (userId) return <Outlet />;
  return null;
}
